export const uploadTypes = {
  entities: 'instruments-entities',
  funds: 'funds',
};

export const uploadSteps = {
  first: 'choose_upload_type',
  second: 'upload_data',
};
